// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Check = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Check = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Check = _exports.Check = function Check(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.49999 14.791C7.49916 14.791 7.49832 14.791 7.49749 14.791C7.33082 14.7902 7.17166 14.7235 7.05416 14.6043L3.72083 11.2193C3.47833 10.9735 3.48166 10.5777 3.72749 10.3352C3.97333 10.0935 4.36999 10.096 4.61166 10.3418L7.5025 13.2785L15.3908 5.39016C15.635 5.14599 16.0308 5.14599 16.275 5.39016C16.5192 5.63432 16.5192 6.03019 16.275 6.27435L7.94166 14.6077C7.82499 14.7252 7.66583 14.791 7.49999 14.791Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.5"
    }));
  };
});
